import { EntityStatus, ShareholderExtendResponse } from 'api';

export const getKycFallbackMessage = (shareholder?: ShareholderExtendResponse | null) => {
  const status = shareholder?.entity?.status;

  if (status === EntityStatus.EntityApproved) {
    return "Our KYC provider cannot verify this holder's information; this holder has been approved by the issuer admin";
  }

  if (status === EntityStatus.EntityAwaitingApproval) {
    return "Our KYC provider cannot verify this holder's information; the issuer admin must approve or decline this holder";
  }

  return 'KYC for this entity has been done outside of our KYC provider';
};
